"use strict";

import angular from "angular";

angular.module("nucont.accounting.group").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        /*
            Mesma forma de URL da empresa: os parametros de periodo sao de QUERY.
            Como segmento de caminho (`/DRE/:date/:view`) eles nao sabem ficar vazios -- as abas
            DRE e Balanco montam o link sem periodo (`params: {}` em
            `accounting-demonstrations.component.js`) e a URL saia `/DRE//mensal`. Pior: o
            `startDate` e o `scenarioId` que o componente grava nao existiam aqui como parametro,
            entao o inicio do periodo e o cenario nunca chegavam a URL -- o link copiado abria em
            outro periodo.
        */
        .state("nucont.accounting.group.demonstrations.accounting.dre", {
            url: "/DRE?date&view&scenarioId&startDate",
            views: {
                "demonstrationAccountingView@nucont.accounting.group.demonstrations.accounting": {
                    component: "accountingDreComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            params: {
                demonstration: { value: "DRE", dynamic: false },
                date: { value: null, dynamic: true },
                startDate: { value: null, dynamic: true },
                view: { value: "mensal", dynamic: true },
                scenarioId: { value: null, dynamic: true },
                stateIndentifier: { value: "dre" }
            },
            bodyClass: "dre-module"
        })
        .state(
            "nucont.accounting.group.demonstrations.accounting.dre.showtime",
            {
                url: "/showtime",
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.dre.showtime.description",
            {
                url: "/descricao",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.accounting.dre": {
                        component: "indicatorDescriptionComponent"
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.dre.showtime.comments",
            {
                url: "/comentarios",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.accounting.dre": {
                        component: "indicatorCommentsComponent"
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.dre.showtime.insights",
            {
                url: "/insights",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.accounting.dre": {
                        component: "indicatorInsightsComponent"
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.dre.comparation",
            {
                url:
                    "/comparacao?month&comparationView&comparationDate&analysisHorizontal&analysisVertical",
                views: {
                    "demonstrationAccountingView@nucont.accounting.group.demonstrations.accounting": {
                        component: "accountingDreComparationComponent",
                        bindings: { companyData: "groupData" }
                    }
                },
                params: {
                    comparationView: { value: null, dynamic: true },
                    comparationDate: { value: null, dynamic: true },
                    analysisHorizontal: { value: null, dynamic: true },
                    analysisVertical: { value: null, dynamic: true },
                    month: { value: null, dynamic: true },
                    stateIndentifier: { value: "dre.comparation" }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.dre.comparation.showtime",
            {
                url: "/showtime",
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.dre.comparation.showtime.description",
            {
                url: "/descricao",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.accounting.dre.comparation": {
                        component: "indicatorDescriptionComponent"
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.dre.comparation.showtime.comments",
            {
                url: "/comentarios",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.accounting.dre.comparation": {
                        component: "indicatorCommentsComponent",
                        bindings: { companyData: "groupData" }
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.dre.comparation.showtime.insights",
            {
                url: "/insights",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.accounting.dre.comparation": {
                        component: "indicatorInsightsComponent"
                    }
                },
                bodyClass: "dre-module"
            }
        );
}
